import { cva } from "class-variance-authority";

/**
 * A setting row inside a `list` group (`VSwitchRowGroup`): 12px by 14px padding; the group card draws the dividers
 * between the rows. In a `tall` group (the guest link settings) every row is at least 56px high, so switch rows and
 * select rows line up. An indented row depends on the row above it: 34px left padding, an L-shaped
 * connector from that row, and its own divider that starts at the text instead of at the card edge (the group hides
 * the full-width divider above it, see `switchRowGroupListClass`).
 */
export const switchRowListCva = cva("relative py-3 pr-3.5", {
  variants: {
    tall: {
      true: "min-h-14",
      false: null,
    },
    indent: {
      true: [
        "pl-[34px]",
        "before:pointer-events-none before:absolute before:top-0 before:left-5 before:h-[22px] before:w-2 before:rounded-bl-md before:border-b-[1.5px] before:border-l-[1.5px] before:border-gray-400 before:content-[''] dark:before:border-dark-500",
        "after:pointer-events-none after:absolute after:-top-px after:right-0 after:left-[34px] after:border-t after:border-gray-200 after:content-[''] dark:after:border-dark-600",
      ],
      false: "pl-3.5",
    },
  },
  defaultVariants: { tall: false, indent: false },
});

/**
 * The list card of a `list` group hides the divider under a row that an indented row (`data-row-indent`) follows: the
 * indented row draws its own, shorter divider.
 */
export const switchRowGroupListClass = "[&_:has(+[data-row-indent])]:border-b-transparent";
